const { deepCopy } = require('../../assets/functions/deepCopy');

const emptyData = {
  transactionTypeId: '',
  guests: '',
  tableId: '',
  clientTransactionId: '',
  transactionId: '',
};

const state = {
  QrcodeData: { ...emptyData },
  onlyDoPrime: false,
  tContent: {},
  primeData: {},
  previousTotal: {
    previousTotalServiceFee: 0,
    previousTotalAmount: 0,
  },
  previousOrder: [],
  currentOrder: [],
};


const mutations = {
  SET_QrcodeData(state, content) {
    state.QrcodeData = { ...content };
  },
  SET_OnlyDoPrime(state, content) {
    state.onlyDoPrime = content;
  },
  SET_tContent(state, content) {
    state.tContent = deepCopy(content);
  },
  SET_PrimeData(state, content) {
    state.primeData = { ...content };
  },
  SET_PreviousTotal(state, content) {
    state.previousTotal = { ...content };
  },
  SET_PreviousOrder(state, content) {
    state.previousOrder = content;
  },
  SET_CurrentOrder(state, content) {
    state.currentOrder = content;
  },
  RESET_UtilsData(state) {
    state.QrcodeData = { ...emptyData };
    state.tContent = {};
    state.primeData = {};
    state.onlyDoPrime = false;
    state.previousTotal = {
      previousTotalServiceFee: 0,
      previousTotalAmount: 0,
    };
    state.previousOrder = [];
    state.currentOrder = [];
  },
};

const actions = {
  setQrcodeData({ commit }, data) {
    commit('SET_QrcodeData', data);
  },
  setOnlyDoPrime({ commit }, data) {
    commit('SET_OnlyDoPrime', data);
  },
  settContent({ commit }, data) {
    commit('SET_tContent', data);
  },
  setPrimeData({ commit }, data) {
    commit('SET_PrimeData', data);
  },
  setPreviousTotal({ commit }, data) {
    commit('SET_PreviousTotal', data);
  },
  setPreviousOrder({ commit }, data) {
    commit('SET_PreviousOrder', data);
  },
  setCurrentOrder({ commit }, data) {
    commit('SET_CurrentOrder', data);
  },
  cleanUtilsData({ commit }) {
    commit('RESET_UtilsData');
  },
};

const getters = {
  QrcodeData: (state) => ({ ...state.QrcodeData }),
  onlyDoPrime: (state) => state.onlyDoPrime,
  tContent: (state) => state.tContent,
  prime: (state) => state.primeData,
  previousTotal: (state) => state.previousTotal,
  previousOrder: (state) => state.previousOrder,
  currentOrder: (state) => state.currentOrder,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
